'use strict';

var _ = require('lodash');

function DialogController ($log, $scope, sbDialogService, sbDialogViewFactory) {
  
  var DEFAULTS = {
    $id: $scope.$id,
    $minimized: false, // flag used internally to stop minimize/maximize from firing twice back-to-back
    $showCloseControl: false,
    $showMinControl: false,
    $visible: false, // flag used internally to stop close/open from firing twice back-to-back
    align: 'top left', // only used when position is an xy coordinate
    animate: 'fadeIn fadeOut',
    controls: 'close',
    group: 'site',
    minimize: false,
    minimizeHeight: '30px',
    position: 'top right',
    show: false,
    view: '', // current view id
    xycoords: [],
  };

  var vm = this;
  var viewManager = null;

  // initialize the controller and related services
  _.defaults(vm, DEFAULTS);
  sbDialogService.register(vm.group, vm);
  viewManager = sbDialogViewFactory.create(vm.$id);

  vm.close = function (e) {
    if (e) {
      close(true);
    } else {
      close();
    }
  };

  vm.collapse = function (e) {
    if (e) {
      if (vm.minimize) {
        maximize(true);
      } else {
        minimize(true);
      }
    } else {
      if (vm.minimize) {
        maximize();
      } else {
        minimize();
      }
    }
  };

  /**
   * Let's the directive have access to the private 'ctrlAttr' function
   * 
   * @param  {String} attr
   * @return {Fn}
   */
  vm.getAttrFn = function (attr) {
    return ctrlAttr(attr);
  };

  vm.getId = function () {
    return vm.$id;
  };

  /**
   * Load the first view
   * If no view id is given it will load the default view.
   * 
   * @param  {string} [id] the id of the view to load
   */
  vm.loadView = function (id) {
    vm.view = viewManager.switchToView(id);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Properties set programmatically
  /////////////////////////////////////////////////////////////////////////////////////////////////

  vm.$showCloseControl = !!~vm.controls.indexOf('close');

  vm.$showMinControl = !!~vm.controls.indexOf('minimize');

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Helpers
  /////////////////////////////////////////////////////////////////////////////////////////////////
  
  var unbindWatchPos;
  var unbindWatchMinimize;

  function cleanupWatch () {
    if (unbindWatchPos) {
      unbindWatchPos();
    }

    if (unbindWatchMinimize) {
      unbindWatchMinimize();
    }
  }

  /**
   * Used internally to create a function that will retrieve a given controller attribute 
   * for $watch
   * 
   * @param  {String} attr
   * @return {Fn}
   */
  function ctrlAttr (attr) {
    return function () {
      return vm[attr];
    };
  }

  /**
   * Used internally to close the dialog
   */
  function close () {
    if (vm.$visible) {
      vm.$visible = false;
      vm.show = false;
      cleanupWatch();
      sbDialogService.closed(vm.$id);
    }
  }

  function minimize () {
    if (!vm.$minimized) {
      vm.$minimized = true;
      vm.minimize = true;
    }
  }

  function maximize () {
    if (vm.$minimized) {
      vm.$minimized = false;
      vm.minimize = false;
    }
  }

  function open () {
    if (!vm.$visible) {
      vm.$visible = true;
      vm.show = true;
      sbDialogService.opened(vm.$id);

      unbindWatchPos = $scope.$watch(ctrlAttr('view'), onViewChange);
      unbindWatchMinimize = $scope.$watch(ctrlAttr('minimize', onMinimizeChange));
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  ///////////////////////////////////////////////////////////////////////////////////////////

  function onDestroy () {
    viewManager.destroy();
    sbDialogService.unregister(vm.group, vm.$id);
    $log.info('Destroyed Dialog: ' + vm.group + ' ' + vm.$id);
  }

  function onMinimizeChange (minimize) {
    if (minimize) {
      minimize();
    } else {
      maximize();
    }
  }

  function onShowChange (show) {
    if (show) {
      open();
    } else {
      close();
    }
  }

  function onSwitchToPreviousView () {
    if (vm.visible) {
      vm.view = viewManager.getPreviousView();
    }
  }

  function onViewChange (newVal) {
    if (newVal) {
      vm.view = viewManager.switchToView(newVal);
    }
  }

  $scope.$watch(ctrlAttr('show'), onShowChange);

  $scope.$on('$destroy', onDestroy);
  $scope.$on('dialog:switchToPreviousView', onSwitchToPreviousView);
}

DialogController.$inject = ['$log', '$scope', 'sbDialogService', 'sbDialogViewFactory'];
module.exports = DialogController;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dialog/src/DialogController.js